export interface AdminLoginInput {
  email: string;
  password: string;
  is_staff : boolean
}

export interface ChangeAdminEmailInput {
  id: string;
  newEmail: string;
  password: string;
}

export interface ChangeAdminPasswordInput {
  staff_id: string;
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export interface ResetAdminPasswordInput {
  newPassword: string;
  confirmNewPassword: string;
}

export interface CustomerLoginInput {
  email: string;
  password: string;
  is_staff ?:boolean;
}
export interface EmailInput {
  email: string;
  is_staff ?:boolean;
}
export interface VarifyEmailCode {
  email: string;
  code: string;
  is_staff ?:boolean;
}

export interface resetPassword {
  newPassword: string;
  token: string;
  is_staff ?:boolean;
}
export interface GtokenInput {
  idToken: string;
}
export interface FtokenInput {
  accessToken: string;
}
